"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameEventActionTypesArray = exports.gameEventCreators = exports.playerEliminatedEvent = exports.playerStreakEvent = exports.playerLevelUpEvent = exports.pieceUpgradedEvent = exports.playerListChangedEvent = exports.gameFinishEvent = exports.gamePhaseStartedEvent = void 0;
const api_1 = require("@cc-plugins/api");
exports.gamePhaseStartedEvent = (0, api_1.networkedAction)("gamePhaseStartedEvent");
exports.gameFinishEvent = (0, api_1.networkedAction)("gameFinishEvent");
exports.playerListChangedEvent = (0, api_1.networkedAction)("playerListChangedEvent");
exports.pieceUpgradedEvent = (0, api_1.networkedAction)("pieceUpgradedEvent");
exports.playerLevelUpEvent = (0, api_1.networkedAction)("playerLevelUpEvent");
exports.playerStreakEvent = (0, api_1.networkedAction)("playerStreakEvent");
exports.playerEliminatedEvent = (0, api_1.networkedAction)("playerEliminatedEvent");
exports.gameEventCreators = [
    exports.gameFinishEvent,
    exports.gamePhaseStartedEvent,
    exports.playerListChangedEvent,
    exports.pieceUpgradedEvent,
    exports.playerLevelUpEvent,
    exports.playerStreakEvent,
    exports.playerEliminatedEvent,
];
exports.GameEventActionTypesArray = exports.gameEventCreators.map((c) => c.type);
